import data from './documents.json'

export type LegalDocumentId = keyof typeof data.documents
export const legalVersion = data.version
export const legalDate = data.date
export const legalDocuments = data.documents
